import { ScopeOfFunctions, WriteScopeOfFunctions } from '@/modules/scopeOfFunctions/types';

export const MapViewToWrite = ({ id, ...scopeOfFunctions }: ScopeOfFunctions): WriteScopeOfFunctions => ({
  scope_of_functions_id: id,
  ...scopeOfFunctions
});
